<template>
  <Card class="map-card1">
    <div class="text-xs-center pt-3 pb-3">LIVE MONITORING</div>
    <v-divider class="custom-divider" />
    <div class="graph-container pa-2">
      <GlobalGraph class="graph" :series="series" :xAxisData="xAxisData" :yAxis="yAxis" :theme="theme" />
    </div>
  </Card>
</template>

<script>
export default {
  name: "LiveMonitoringCard",
  props: {
    series: Array,
    xAxisData: Array,
    yAxis: Array,
    theme: String,
  },
};
</script>

<style scoped>
.map-card1 {
  height: 464px;
  border: 1px solid #334079 !important;
  border-radius: 8px;
  box-shadow: 0px 5px 5px 0px #334079;
}

.graph-container {
  height: calc(100% - 60px);
  width: 100%;
}

.graph {
  width: 100%;
  height: 100% !important;
}

.custom-divider {
  border-color: #334079 !important;
}
</style>
